import { gateway } from "src/gateway";
import { IBulkImportClientsPayload, IBulkImportClientsResponse, IClientImportRow } from "../interfaces/Client.interface";

export async function bulkImportClientsAction({
  clients,
  status,
}: {
  clients: IClientImportRow[];
  status?: string;
}): Promise<IBulkImportClientsResponse> {
  try {
    const payload: IBulkImportClientsPayload = {
      clients: clients.map((c) => ({
        ...normalizeClientImportRow(c),
        status: status || c.status || undefined,
      })),
    };

    const response = await gateway.post<IBulkImportClientsResponse>("/clients/bulk-import", payload);
    return response.data;
  } catch (error) {
    return error as any;
  }
}

function normalizeClientImportRow(row: IClientImportRow): IClientImportRow {
  return {
    firstName: normalizeRequiredText(row.firstName),
    lastName: normalizeOptionalText(row.lastName),
    email: normalizeOptionalText(row.email),
    phone: normalizeOptionalText(row.phone),
    address: normalizeOptionalText(row.address),
    city: normalizeOptionalText(row.city),
    state: normalizeOptionalText(row.state),
    zipCode: normalizeOptionalText(row.zipCode),
    clientCompanyName: normalizeOptionalText(row.clientCompanyName),
    type: normalizeOptionalText(row.type),
    status: normalizeOptionalText(row.status),
  };
}

function normalizeRequiredText(value: unknown): string {
  return String(value ?? "").trim();
}

function normalizeOptionalText(value: unknown): string | undefined {
  const text = String(value ?? "").trim();

  return text.length > 0 ? text : undefined;
}
